import { useEffect } from "react";

interface AIModalBridgeOptions {
  setSchedulerState: (state: any) => void;
  setSelectedClientForModal: (client: any) => void;
  setIsEditClientModalOpen: (open: boolean) => void;
  setIsAddClientModalOpen: (open: boolean) => void;
  setSelectedContact: (contact: any) => void;
  setIsEditContactModalOpen: (open: boolean) => void;
  setIsAddContactModalOpen: (open: boolean) => void;
  setIsImportContactModalOpen: (open: boolean) => void;
  fetchClientDataAndOpenEditModal: (clientId: string, clientName?: string) => void;
  fetchContactDataAndOpenEditModal: (contactId: string, contactName?: string) => void;
}

export function useAIModalBridge({
  setSchedulerState,
  setSelectedClientForModal,
  setIsEditClientModalOpen,
  setIsAddClientModalOpen,
  setSelectedContact,
  setIsEditContactModalOpen,
  setIsAddContactModalOpen,
  setIsImportContactModalOpen,
  fetchClientDataAndOpenEditModal,
  fetchContactDataAndOpenEditModal,
}: AIModalBridgeOptions) {
  useEffect(() => {
    const handleAIModalRequest = (event: any) => {
      const data = event.detail || event;
      const modalName = data.modalName || data.targetModal;
      const params = data.params || data.modalParams || data.initialData;

      if (modalName === "MeetingScheduler") {
        setSchedulerState({
          open: true,
          mode: params?.mode || "create",
          initialData: params || null,
          context: "global",
        });
      } else if (modalName === "ClientModal") {
        if (params?.mode === "edit" || params?.clientId) {
          if (params?.clientId) {
            fetchClientDataAndOpenEditModal(params.clientId, params.clientName);
          } else {
            setSelectedClientForModal(params);
            setIsEditClientModalOpen(true);
          }
        } else {
          setSelectedClientForModal(null);
          setIsAddClientModalOpen(true);
        }
      } else if (modalName === "ContactModal") {
        if (params?.mode === "edit" || params?.contactId) {
          if (params?.contactId) {
            fetchContactDataAndOpenEditModal(params.contactId, params.contactName);
          } else {
            setSelectedContact(params);
            setIsEditContactModalOpen(true);
          }
        } else {
          setSelectedContact(null);
          setIsAddContactModalOpen(true);
        }
      } else if (modalName === "ImportContactDialog") {
        setIsImportContactModalOpen(true);
      }
    };

    window.addEventListener("ai-open-modal", handleAIModalRequest);
    return () => window.removeEventListener("ai-open-modal", handleAIModalRequest);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
